var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "my_edit_item my_color_layer" }, [
    _vm.is_page_background
      ? _c("div", { staticClass: "color-cube-wrapper" }, [
          _c("div", { staticClass: "title" }, [_vm._v("背景颜色")]),
          _c("div", {
            staticClass: "color-cube color-cube-main",
            style: { background: _vm.my_color },
            on: { click: _vm.picker_open },
          }),
          _c("div", { staticClass: "quick-panel" }, [
            _c(
              "div",
              { staticClass: "row-color row-1" },
              _vm._l(
                _vm.quick_color_config.slice(0, 5),
                function (color, index) {
                  return _c("div", {
                    key: index,
                    class: ["quick-cube", "quick-cube-" + index],
                    on: {
                      click: function ($event) {
                        return _vm.on_click_quick_color(color)
                      },
                    },
                  })
                }
              ),
              0
            ),
            _c(
              "div",
              { staticClass: "row-color" },
              _vm._l(
                _vm.quick_color_config.slice(5, 10),
                function (color, index) {
                  return _c("div", {
                    key: index,
                    class: ["quick-cube", "quick-cube-" + (index + 5)],
                    on: {
                      click: function ($event) {
                        return _vm.on_click_quick_color(color)
                      },
                    },
                  })
                }
              ),
              0
            ),
          ]),
        ])
      : _c("div", { staticClass: "normal-color-wrapper" }, [
          !_vm.svg
            ? _c(
                "span",
                { staticClass: "color_box", on: { click: _vm.picker_open } },
                [
                  _c("span", {
                    staticClass: "color_block",
                    class:
                      _vm.my_color === "rgba(254,254,254,0)"
                        ? "color_block_transparent"
                        : "",
                    style: {
                      background: _vm.my_color,
                      "border-radius": "4px 0px 0px 4px",
                    },
                  }),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/change_color.png"),
                      alt: "",
                    },
                  }),
                ]
              )
            : _c(
                "span",
                {
                  staticClass: "color_block",
                  class:
                    _vm.my_color === "rgba(254,254,254,0)"
                      ? "color_block_transparent"
                      : "",
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                  },
                  on: { click: _vm.picker_open },
                },
                [_c("svg-icon", { attrs: { "icon-class": "color" } })],
                1
              ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }